<template>
  <div class="page-content -column -column-two">
    <h3 class="section-title -mb">Matcher Thresholds</h3>

    <label>Match Threshold <small>(default: 40)</small></label>
    <p class="hint">How close a match should be to be considered a good category for a question.</p>
    <input v-model="resource.match_threshold" type="number" />
    <span v-if="errors.match_threshold" class="alert -inline -danger">
      {{ [...errors.match_threshold].join(', ') }}
    </span>

    <label>Classifier Percentage <small>(default: 50)</small></label>
    <p class="hint">Weighing of the classifier results towards the overall categorization of a question.</p>
    <input v-model="resource.classifier_pct" type="number" />
    <span v-if="errors.classifier_pct" class="alert -inline -danger">
      {{ [...errors.classifier_pct].join(', ') }}
    </span>

    <label>Keyword Percentage <small>(default: 50)</small></label>
    <p class="hint">Weighing of the keyword results towards the overall categorization of a question.</p>
    <input v-model="resource.keyword_pct" type="number" />
    <span v-if="errors.keyword_pct" class="alert -inline -danger">
      {{ [...errors.keyword_pct].join(', ') }}
    </span>

    <label>Keyword Threshold <small>(default: 7)</small></label>
    <p class="hint">The top score for a keyword match (anything with this score or above is seen as a 100% match).</p>
    <input v-model="resource.keyword_threshold" type="number" />
    <span v-if="errors.keyword_threshold" class="alert -inline -danger">
      {{ [...errors.keyword_threshold].join(', ') }}
    </span>

    <label>Min Keyword Match <small>(default: 30)</small></label>
    <p class="hint">The minimum keyword score (anything under this score will be debunct to 0%).</p>
    <input v-model="resource.min_keyword_match" type="number" />
    <span v-if="errors.min_keyword_match" class="alert -inline -danger">
      {{ [...errors.min_keyword_match].join(', ') }}
    </span>

    <label>Min Negative Keyword Match <small>(default: 90)</small></label>
    <p class="hint">
      The minimum negative keyword score (any negative keywords over this score will be debunct to 0%).
    </p>
    <input v-model="resource.min_negative_keyword_match" type="number" />
    <span v-if="errors.min_negative_keyword_match" class="alert -inline -danger">
      {{ [...errors.min_negative_keyword_match].join(', ') }}
    </span>

    <label>Keyword Word Length Variable <small>(default: 10)</small></label>
    <p class="hint">
      Variable used to bump up the score for longer words which closely match. i.e. a 10 character word with a '2'
      score, should have a better rank than 6 character word with '2' score.
    </p>
    <input v-model="resource.keyword_word_length_var" type="number" />
    <span v-if="errors.keyword_word_length_var" class="alert -inline -danger">
      {{ [...errors.keyword_word_length_var].join(', ') }}
    </span>

    <label>Classifier Threshold <small>(default: -15)</small></label>
    <p class="hint">
      The minimum score to be considered as a viable category. This threshold is then used as a base for calculating the
      results percentage.
    </p>
    <input v-model="resource.classifier_threshold" type="number" />
    <span v-if="errors.classifier_threshold" class="alert -inline -danger">
      {{ [...errors.classifier_threshold].join(', ') }}
    </span>

    <action-button class="-mt" :text="'Update Settings'" :state="state" @pressed="submit"></action-button>
  </div>
</template>

<script>
import actionButton from "@/components/actionButton";
import settingsBase from "@/components/settings/base.vue";

export default {
  components: { actionButton },
  extends: settingsBase,

  data() {
    return {
      fields: [
        "match_threshold",
        "classifier_pct",
        "keyword_pct",
        "keyword_threshold",
        "min_keyword_match",
        "min_negative_keyword_match",
        "keyword_word_length_var",
        "classifier_threshold"
      ]
    };
  }
};
</script>
